import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  Button,
  Grid,
  Menu,
  MenuItem,
  Typography,
  useTheme,
} from "@mui/material";
import { DatePicker } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { IoCalendar, IoChevronDown } from "react-icons/io5";
import {
  shape,
  instanceOf,
  oneOf,
  string,
  bool,
  func,
  number,
} from "prop-types";
import { useTextDomainContext } from "@/app/providers";
import { getMinDate, getMaxDate } from "@/utils";

export const SingleDatePickerDmy = (props: any) => {
  // console.log(props);

  const { getSelectedDate } = props;
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const localStorageKey = "MultiDatePickerDmy";
  const theme = useTheme();

  const cacheValues = JSON.parse(localStorage.getItem(localStorageKey));

  let defaultSelectedDate = new Date();
  defaultSelectedDate.setDate(1);
  defaultSelectedDate.setMonth(defaultSelectedDate.getMonth() - 1);

  // let defaultStartDate = new Date();
  // let defaultEndDate = new Date();
  let defaultSegmentIndex = 0;
  let defaultSegmentName = "year";

  if (cacheValues?.selectedDate) {
    defaultSelectedDate = new Date(cacheValues.selectedDate);
  } else if (typeof props.selectedDate !== "undefined") {
    defaultSelectedDate = new Date(props.selectedDate);
  }

  // if (cacheValues?.startDate) {
  //   defaultStartDate = new Date(cacheValues.startDate);
  // } else if (typeof props.startDate !== "undefined") {
  //   defaultStartDate = new Date(props.startDate);
  // }
  //
  // if (cacheValues?.endDate) {
  //   defaultEndDate = new Date(cacheValues.endDate);
  // } else if (typeof props.endDate !== "undefined") {
  //   defaultEndDate = new Date(props.endDate);
  // }

  if (cacheValues?.segmentIndex) {
    defaultSegmentIndex = cacheValues.segmentIndex;
  } else if (typeof props.segmentIndex !== "undefined") {
    defaultSegmentIndex = props.segmentIndex;
  }

  if (cacheValues?.segmentName) {
    defaultSegmentName = cacheValues.segmentName;
  } else if (typeof props.segmentName !== "undefined") {
    defaultSegmentName = props.segmentName;
  }

  //#region React Hooks (useMemo)

  const showHourly = useMemo(() => {
    return props.showHourly || false;
  }, [props.showHourly]);

  const showDaily = useMemo(() => {
    return props.showDaily || false;
  }, [props.showDaily]);

  const showMonthly = useMemo(() => {
    return props.showMonthly || false;
  }, [props.showMonthly]);

  //#endregion React Hooks (useMemo)

  const propsDefault = {
    // note: gettext("Select date range"),
    selectedDate: defaultSelectedDate,
    // selectedDate: {
    //   startDate: defaultStartDate,
    //   endDate: defaultEndDate,
    // },
    segmentIndex: defaultSegmentIndex,
    segmentName: defaultSegmentName,
  };

  //region UseState [React Hooks]
  const [selectedSegment, setSelectedSegment] = useState(
    propsDefault.segmentName,
  );
  // const [startDate, setStartDate] = useState(
  //   propsDefault.selectedDate.startDate,
  // );
  // const [endDate, setEndDate] = useState(propsDefault.selectedDate.endDate);
  const [selectedDate, setSelectedDate] = useState(propsDefault.selectedDate);
  const [anchorEl, setAnchorEl] = useState<any>(null);
  const [segmentIndex, setSegmentIndex] = useState<any>(
    propsDefault.segmentIndex,
  );
  //endregion useState

  const handleSegmentClose = () => {
    setAnchorEl(null);
  };

  //region useEffect [React Hooks]
  // useEffect(() => {
  //   const start = startDate;
  //   const end = endDate;
  //   if (start && end) {
  //     let dateStart = start;
  //     let dateEnd = end;
  //
  //     const startYear = start.getFullYear();
  //     const startMonth = start.getMonth();
  //     const startDay = start.getDate();
  //
  //     const endYear = end.getFullYear();
  //     const endMonth = end.getMonth();
  //     const endDay = end.getDate();
  //
  //     switch (selectedSegment) {
  //       case "year":
  //         dateStart = new Date(startYear, 0, 1, 0, 0, 0);
  //         dateEnd = new Date(new Date(endYear + 1, 0, 1, 0, 0, 0) - 1);
  //         break;
  //       case "month":
  //         dateStart = new Date(startYear, startMonth, 1, 0, 0, 0);
  //         dateEnd = new Date(new Date(endYear, endMonth + 1, 1, 0, 0, 0) - 1);
  //         break;
  //       default:
  //         dateStart = new Date(startYear, startMonth, startDay, 0, 0, 0);
  //         dateEnd = new Date(
  //           new Date(endYear, endMonth, endDay + 1, 0, 0, 0) - 1,
  //         );
  //         break;
  //     }
  //
  //     if (typeof getSelectedDate === "function") {
  //       getSelectedDate(
  //         {
  //           startDate: dateStart,
  //           endDate: dateEnd,
  //         },
  //         selectedSegment,
  //       );
  //     }
  //     handleSegmentClose();
  //   }
  // }, [endDate, getSelectedDate, selectedSegment, startDate]);

  useEffect(() => {
    const selected = selectedDate;
    if (selected) {
      const selectedYear = selected.getFullYear();
      const selectedMonth = selected.getMonth();
      const selectedDay = selected.getDate();

      let _dateSelected = selected;

      switch (selectedSegment) {
        case "year":
          _dateSelected = new Date(selectedYear, 0, 1, 0, 0, 0);
          break;
        case "month":
          _dateSelected = new Date(selectedYear, selectedMonth, 1, 0, 0, 0);
          break;
        default:
          _dateSelected = new Date(
            selectedYear,
            selectedMonth,
            selectedDay,
            0,
            0,
            0,
          );
          break;
      }

      if (typeof getSelectedDate === "function") {
        getSelectedDate(selectedDate, selectedSegment);
      }
      // Remove handleSegmentClose() call to avoid cascading renders
    }
  }, [getSelectedDate, selectedDate, selectedSegment]);
  // }, []);

  // useEffect(() => {
  //   const item = {
  //     startDate,
  //     endDate,
  //     segmentIndex,
  //     selectedSegment
  //   };
  //   localStorage.setItem(localStorageKey, JSON.stringify(item));
  // }, [endDate, segmentIndex, selectedSegment, startDate]);

  //endregion useEffect

  //region Handlers
  const handleSegmentClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  // const handleDateChange = (event) => {
  //   const [start, end] = event;
  //   setStartDate(start);
  //   setEndDate(end);
  //   if (start && end) {
  //     const item = {
  //       startDate: start,
  //       endDate: end,
  //       segmentIndex,
  //       selectedSegment,
  //     };
  //
  //     localStorage.setItem(localStorageKey, JSON.stringify(item));
  //
  //     handleSegmentClose();
  //   }
  // };

  const handleDateChange = (event: any) => {
    setSelectedDate(event);
    if (selectedDate) {
      const item = {
        selectedDate,
        segmentIndex,
        selectedSegment,
      };

      localStorage.setItem(localStorageKey, JSON.stringify(item));

      handleSegmentClose();
    }
  };

  const handleSegmentSelect = (segmentName: any) => {
    setSelectedSegment(segmentName);
    let selectedSegmentIndex;
    if (segmentName === "day") {
      selectedSegmentIndex = 0;
      // setSegmentIndex(0);
    } else if (selectedSegment === "month") {
      selectedSegmentIndex = 1;
      // setSegmentIndex(1);
    } else {
      selectedSegmentIndex = 2;
      // setSegmentIndex(2);
    }
    setSegmentIndex(selectedSegmentIndex);

    const item = {
      selectedDate,
      selectedSegmentIndex,
      segmentName,
    };

    // const item = {
    //   startDate,
    //   endDate,
    //   selectedSegmentIndex,
    //   segmentName,
    // };

    localStorage.setItem(localStorageKey, JSON.stringify(item));
    handleSegmentClose();
  };
  //endregion Handlers

  const formattedDate = () => {
    let dateSelected = new Date();
    if (selectedDate) {
      dateSelected = selectedDate;
    }

    // let dateStart = new Date();
    // let dateEnd = new Date();
    // if (startDate) {
    //   dateStart = startDate;
    // }
    //
    // if (endDate) {
    //   dateEnd = endDate;
    // }

    const daySelected = dateSelected.getDate();

    const monthSelected = dateSelected.toLocaleString("default", {
      month: "short",
    });
    const yearSelected = dateSelected.getFullYear();

    // const dayStart = dateStart.getDate();
    // const monthStart = dateStart.toLocaleString("default", {
    //   month: "short",
    // });
    // const yearStart = dateStart.getFullYear();
    // const dayEnd = dateEnd.getDate();
    // const monthEnd = dateEnd.toLocaleString("default", {
    //   month: "short",
    // });
    // const yearEnd = dateEnd.getFullYear();

    if (selectedSegment === "year") {
      // return `${yearStart} - ${yearEnd}`;
      return `${yearSelected}`;
    } else if (selectedSegment === "month") {
      // return `${monthStart} ${yearStart} - ${monthEnd} ${yearEnd}`;
      return `${monthSelected} ${yearSelected}`;
    } else {
      // return `${dayStart} ${monthStart} ${yearStart} - ${dayEnd} ${monthEnd} ${yearEnd}`;
      return `${daySelected} ${monthSelected} ${yearSelected}`;
    }
  };

  const renderDatePicker = () => {
    switch (selectedSegment) {
      case "year":
        return (
          <DatePicker
            className="my-datepicker"
            selected={selectedDate}
            // startDate={startDate}
            // endDate={endDate}
            onChange={handleDateChange}
            dateFormat="yyyy"
            showMonthDropdown={false}
            showYearPicker
            dropdownMode="select"
            // selectsRange
            inline
            // minDate={
            //     futureDates === false &&
            //     new Date().setMonth(new Date().getMonth())
            // }
            minDate={props.minDate || getMinDate(props.pastYears)}
            maxDate={
              props.maxDate ||
              getMaxDate(props.futureYears ?? props.futureDates)
            }

            dayClassName={(date) => {
              // return date.getMonth() !== startDate.getMonth() ? "disabled" : "";
              return date.getMonth() !== selectedDate.getMonth()
                ? "disabled"
                : "";
            }}
          >
            {/*<Typography fontSize="14px" color={"secondary.900"}>*/}
            {/*  {propsDefault.note}*/}
            {/*</Typography>*/}
          </DatePicker>
        );
      case "month":
        return (
          <DatePicker
            className="my-datepicker"
            selected={selectedDate}
            // startDate={startDate}
            // endDate={endDate}
            onChange={handleDateChange}
            dateFormat="MMMM yyyy"
            showMonthYearPicker
            // selectsRange
            inline
            // minDate={
            //     futureDates === false &&
            //     new Date().setMonth(new Date().getMonth())
            // }
            minDate={props.minDate || getMinDate(props.pastYears)}
            maxDate={
              props.maxDate ||
              getMaxDate(props.futureYears ?? props.futureDates)
            }
            dayClassName={(date) => {
              // return date.getMonth() !== startDate.getMonth() ||
              //   date.getFullYear() !== startDate.getFullYear()
              //   ? "disabled"
              //   : "";
              return date.getMonth() !== selectedDate.getMonth() ||
                date.getFullYear() !== selectedDate.getFullYear()
                ? "disabled"
                : "";
            }}
          >
            {/*<Typography fontSize="14px" color={"secondary.900"}>*/}
            {/*  {propsDefault.note}*/}
            {/*</Typography>*/}
          </DatePicker>
        );
      case "day":
      default:
        return (
          <DatePicker
            // className="my-datepicker"
            selected={selectedDate}
            // startDate={startDate}
            // endDate={endDate}
            onChange={handleDateChange}
            dateFormat="dd MMMM yyyy"
            // selectsRange
            inline
            minDate={props.minDate || getMinDate(props.pastYears)}
            maxDate={
              props.maxDate ||
              getMaxDate(props.futureYears ?? props.futureDates)
            }
            dayClassName={(date) => {
              // return date.getMonth() !== startDate.getMonth() ? "disabled" : "";
              return date.getMonth() !== selectedDate.getMonth()
                ? "disabled"
                : "";
            }}
          >
            {/*<Typography fontSize="14px" color={"secondary.900"}>*/}
            {/*  {propsDefault.note}*/}
            {/*</Typography>*/}
          </DatePicker>
        );
    }
  };

  return (
    <>
      {props.view === "table" ? (
        <Button
          endIcon={<IoChevronDown size={12} />}
          size="small"
          onClick={handleSegmentClick}
          sx={{
            width: "160px",
            "&:hover": {
              backgroundColor: "#fff",
              border: "1px solid #E4E4E7",
            },
          }}
        >
          <Typography
            sx={{ fontSize: "14px", fontWeight: "500", color: "secondary.800" }}
          >
            Calender
          </Typography>
        </Button>
      ) : (
        <Button
          variant="outlined"
          size="large"
          // color="secondary"
          style={{
            color: theme.palette.grey[600],
            // height: "32px",
          }}
          endIcon={<IoCalendar />}
          onClick={handleSegmentClick}
        >
          <Typography
            noWrap
            sx={{ fontSize: "14px", fontWeight: "fontWeightMedium" }}
          >
            {formattedDate()}
          </Typography>
        </Button>
      )}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleSegmentClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          ".MuiMenu-list": {
            padding: 0,
            height: "100%",
          },
          "& .MuiMenu-paper": {
            width: "412px",
            borderRadius: "8px",
            boxShadow:
              "0px 10px 15px -3px #0000001A ,0px 4px 6px -2px #0000000F",
            overflow: "hidden",
          },
          "& .MuiMenuItem-root": {
            fontWeight: 400,
            fontSize: "14px",
          },
          "& .MuiMenuItem-root.Mui-selected": {
            backgroundColor: "secondary.900",
            fontWeight: 600,
            fontSize: "14px",
            color: "white",
          },
          // Year picker specific styles
          "& .react-datepicker__year-wrapper": {
            display: "flex",
            flexWrap: "wrap",
            gap: "8px",
            padding: "8px",
            maxWidth: "280px",
          },
          "& .react-datepicker__year .react-datepicker__year-text": {
            display: "flex",
            color: "#27272a",
            width: "calc(33.333% - 6px)",
            height: "50px",
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            padding: 0,
            margin: 0,
            borderRadius: "4px",
          },
          "& .react-datepicker__year-text:hover": {
            backgroundColor: "secondary.100",
          },
          "& .react-datepicker__year-text--selected": {
            backgroundColor: "secondary.900 !important",
            color: "white !important",
            fontWeight: 600,
          },
          "& .react-datepicker__year-text--disabled": {
            color: "#d4d4d8",
            cursor: "not-allowed",
          },
          // Month picker specific styles
          "& .react-datepicker__monthPicker": {
            padding: "8px",
          },
          "& .react-datepicker__monthPicker .react-datepicker__month-wrapper": {
            display: "flex",
            gap: "8px",
          },
          "& .react-datepicker__monthPicker .react-datepicker__month-text": {
            display: "flex",
            // color: "#27272a",
            // width: "calc(33.333% - 6px)",
            height: "50px",
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            // padding: 0,
            // margin: 0,
            // borderRadius: "4px",
          },
          "& .react-datepicker__monthPicker .react-datepicker__month-text:hover":
            {
              backgroundColor: "secondary.100",
            },
          "& .react-datepicker__monthPicker .react-datepicker__month-text--selected":
            {
              backgroundColor: "secondary.900 !important",
              color: "white !important",
              fontWeight: 600,
            },
          "& .react-datepicker__monthPicker .react-datepicker__month-text--disabled":
            {
              color: "#d4d4d8",
              cursor: "not-allowed",
            },
          // Common header styles
          "& .react-datepicker__header": {
            backgroundColor: "#fff",
            color: "#27272a",
            borderBottom: "none",
            fontWeight: 600,
            fontSize: "16px",
            paddingTop: "10px",
          },
        }}
      >
        {/*<Grid container columnSpacing={1} xs={12}>*/}
        <Grid container columnSpacing={1} sx={{ width: "100%" }}>
          <Grid
            size={{
              xs: 4,
            }}
            sx={{
              borderRight: "1px solid #E4E4E7",
            }}
          >
            {showHourly && (
              <MenuItem
                disabled={props.disableSegments && segmentIndex !== 0}
                selected={selectedSegment === "day"}
                onClick={() => handleSegmentSelect("day")}
              >
                {gettext("Hourly")}
              </MenuItem>
            )}
            {showDaily && (
              <MenuItem
                disabled={props.disableSegments && segmentIndex !== 1}
                selected={selectedSegment === "month"}
                onClick={() => handleSegmentSelect("month")}
              >
                {gettext("Daily")}
              </MenuItem>
            )}
            {showMonthly && (
              <MenuItem
                disabled={props.disableSegments && segmentIndex !== 2}
                selected={selectedSegment === "year"}
                onClick={() => handleSegmentSelect("year")}
              >
                {gettext("Monthly")}
              </MenuItem>
            )}
          </Grid>
          <Grid
            size={{
              xs: 8,
            }}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {renderDatePicker()}
          </Grid>
        </Grid>
      </Menu>
    </>
  );
};

// TODO: futureDates and disableSegments is not properly working. We need to fix that
SingleDatePickerDmy.propTypes = {
  selectedDate: shape({
    startDate: instanceOf(Date),
    endDate: instanceOf(Date),
  }),
  segment: oneOf(["day", "month", "year"]),
  view: string,
  futureDates: bool,
  disableSegments: bool,
  getSelectedDate: func.isRequired,
  startDate: instanceOf(Date),
  endDate: instanceOf(Date),
  segmentIndex: number,
  segmentName: string,
  showHourly: bool,
  showDaily: bool,
  showMonthly: bool,
};
